import { isODMBasketErrorResponse } from 'utilities/basket/basketUtilities';
import { DEFAULT_BASKET_ERROR_MESSAGE } from 'constants/basket';
import { ODMBasketResponse } from 'types/ODMTypes';
import { BasketResponse } from '../../../types/BasketTypes';

const adaptBasketResponse = (
  response: ODMBasketResponse & {
    ok?: boolean;
  },
): BasketResponse => {
  if (isODMBasketErrorResponse(response)) {
    return {
      errorCode: response.error.errors[0].key,
      message: response.error.errors[0].errors[0] || DEFAULT_BASKET_ERROR_MESSAGE,
      status: response.status,
      success: false,
    };
  }

  if ((response.ok !== undefined && !response.ok) || response.status < 200 || response.status >= 300) {
    return {
      errorCode: response?.error?.errors?.[0]?.key ?? 'unknown_error',
      message: DEFAULT_BASKET_ERROR_MESSAGE,
      status: response.status,
      success: false,
    };
  }

  return {
    message: '',
    status: 200,
    success: true,
  };
};

export default adaptBasketResponse;
